import { useSyncExternalStore } from 'react'
import { railLayout } from '../lib/railLayout'

/**
 * useRailInset — px to add to a left-edge viewport overlay's `left` so it clears
 * the docked Outliner rail. 0 when the rail isn't mounted.
 *
 * useSyncExternalStore, NOT useState + useEffect(subscribe). The naive version
 * has a real race that showed up immediately: the rail publishes its width from
 * an effect, and it sits EARLIER in App's tree than its consumers, so on the
 * commit where both mount the publish happens before the consumer subscribes.
 * The consumer's initial snapshot is 0, the notification already fired, and
 * because setWidth short-circuits on an unchanged value there is no second one —
 * so the overlay stays at inset 0 (visibly under the rail) until the next
 * collapse toggle. useSyncExternalStore re-reads the snapshot after subscribing,
 * which closes exactly that gap.
 *
 * See railLayout for why the width is a singleton rather than a prop.
 */
export function useRailInset() {
  return useSyncExternalStore(
    railLayout.subscribe,
    railLayout.getWidth,
    // Server/prerender snapshot: no rail, no inset.
    () => 0,
  )
}
